import { createService } from '@/helpers/hasura'

import gql from 'graphql-tag'

import { ProductFileFragment, FileFragment } from '@/helpers/api/fragments'

const output = `
  ...ProductFile
  file {
    ...File
  }
`
const fragments = gql`
  ${ProductFileFragment}
  ${FileFragment}
`

const allowedFields = ['product_id', 'file_id']

export default config => {
  const service = createService({
    ...config,
    table: 'product_file',
    defaultSearchBy: [],
    primaryKey: ['product_id', 'file_id'],
    defaultOrderBy: [],
    defaultFilters: [],
    defaultOutput: output,
    defaultFragments: fragments,
    allowedFields
  })

  return {
    ...service
  }
}
